import { FetchBaseQueryError, createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import type { QueryReturnValue } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import {
  CashbackAccountStats,
  CashbackHistoryOperation,
  CashbackUpcomingExpiration,
  PaginatedResponse,
} from '../../services/exports/Interfaces';
import ProfileManager from '../../services/api/ProfileManager';

export interface GetCashbackOperationsArgs {
  companyId: number;
  page?: number;
  pageSize?: number;
}

export const cashbackApiSlice = createApi({
  baseQuery: fakeBaseQuery(),
  reducerPath: 'cashbackApiSlice',
  endpoints: (build) => ({
    getCashbackUpcomingExpiration: build.query<
      QueryReturnValue<CashbackUpcomingExpiration | null, FetchBaseQueryError>,
      number
    >({
      queryFn: (companyId) =>
        ProfileManager.getCashbackUpcomingExpiration(companyId).then((res) => {
          if (res.success) {
            return { data: res.response.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
    }),
    getCashbackOperations: build.query<PaginatedResponse<CashbackHistoryOperation>, GetCashbackOperationsArgs>({
      queryFn: ({ companyId, page, pageSize }) =>
        ProfileManager.getCashbackOperations(companyId, { page, page_size: pageSize }).then((res) => {
          if (res.success) {
            return { data: res.response.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
    }),
    getCashbackOperationsStats: build.query<QueryReturnValue<CashbackAccountStats, FetchBaseQueryError>, number>({
      queryFn: (companyId) =>
        ProfileManager.getCashbackOperationsStats(companyId).then((res) => {
          if (res.success) {
            return { data: res.response.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
    }),
  }),
});

export const {
  useGetCashbackUpcomingExpirationQuery,
  useLazyGetCashbackUpcomingExpirationQuery,
  useGetCashbackOperationsQuery,
  useLazyGetCashbackOperationsQuery,
  useGetCashbackOperationsStatsQuery,
} = cashbackApiSlice;
